export enum ErrorType {
  NetworkError = 'Network Error',
  ResourceError = 'Resource Error',
}
